export const DEFAULT_COLORS = {
  indentMarkerColor: 'rgba(189, 238, 255, .1)',
  indentMarkerColorActive: 'rgba(194, 245, 255, 0.5)',
  //   active: rgba(194, 245, 255, 0.8)  regular: rgba(189, 238, 255, .3)
  textColor: 'rgba(51, 51, 51, 1)',
  pageBgColor: 'rgba(255, 255, 255, 0.31)',
};

export const PRESETS = {
  preset1: {
    textColor: 'rgba(51, 51, 51, 1)',
    pageBgColor: 'rgba(255, 255, 255, 0.31)',
  },
  preset2: {
    textColor: 'rgba(255, 255, 255, 1)',
    pageBgColor: 'rgba(0, 0, 0, 0)',
  },
};
